import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './amazon.module.scss'

interface SubscribeCouponProps {
  couponPercent: number
}

const SubscribeCoupon = ({ couponPercent }: SubscribeCouponProps) => {
  const { t } = useSurveyLocale()

  return (
    <div className={style.subscribeCoupon}>
      <span className={style.subscribeCouponLabel}>{t('questions', 'ec', 'amazon', 'couponLabel')}</span>
      <EmptyLink>
        <div className={style.subscribeCouponCheckbox} />
      </EmptyLink>
      <span
        className={style.subscribeCouponText}
        dangerouslySetInnerHTML={{
          __html: t<(percent: number) => string>('questions', 'ec', 'amazon', 'subscribeCoupon')(couponPercent)
        }}
      />{' '}
      <EmptyLink>
        <span className={style.subscribeCouponTerms}>{t('questions', 'ec', 'amazon', 'terms')}</span>
      </EmptyLink>
    </div>
  )
}

export default SubscribeCoupon
